// LogoutButton.js
import React from 'react';
import { useAuth } from './AuthContext';

const LogoutButton = () => {
  const { logout } = useAuth();

  return (
    <div className="fixed top-4 right-4 z-50">
      <button
        onClick={logout}
        className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded shadow flex items-center"
      >
        <span>Déconnexion</span>
      </button>
    </div>
  );
};

export default LogoutButton;